import _definePage_default_0 from '/app/src/pages/app/[...error].vue?definePage&vue'
import { _mergeRouteRecord } from 'unplugin-vue-router/runtime'
import _definePage_default_2 from '/app/src/pages/app/care-visit/customers/index.vue?definePage&vue'
import _definePage_default_3 from '/app/src/pages/app/care-visit/dashboard/index.vue?definePage&vue'
import _definePage_default_4 from '/app/src/pages/app/care-visit/kiosks/index.vue?definePage&vue'
import _definePage_default_5 from '/app/src/pages/app/care-visit/locations/index.vue?definePage&vue'
import _definePage_default_6 from '/app/src/pages/app/care-visit/sessions/index.vue?definePage&vue'
import _definePage_default_7 from '/app/src/pages/app/care-visit/visiting-rules/index.vue?definePage&vue'
import _definePage_default_8 from '/app/src/pages/app/care-visit/visitors/index.vue?definePage&vue'
import _definePage_default_9 from '/app/src/pages/app/common/notifications/index.vue?definePage&vue'
import _definePage_default_10 from '/app/src/pages/app/feedback/auth/role.vue?definePage&vue'
import _definePage_default_11 from '/app/src/pages/app/feedback/capa-management.vue?definePage&vue'
import _definePage_default_12 from '/app/src/pages/app/feedback/customer-communication.vue?definePage&vue'
import _definePage_default_13 from '/app/src/pages/app/feedback/dashboard/index.vue?definePage&vue'
import _definePage_default_14 from '/app/src/pages/app/feedback/dashboard/complaint.vue?definePage&vue'
import _definePage_default_15 from '/app/src/pages/app/feedback/dashboard/department/index.vue?definePage&vue'
import _definePage_default_16 from '/app/src/pages/app/feedback/dashboard/feedback.vue?definePage&vue'
import _definePage_default_17 from '/app/src/pages/app/feedback/dashboard/location/index.vue?definePage&vue'
import _definePage_default_18 from '/app/src/pages/app/feedback/dashboard/question/index.vue?definePage&vue'
import _definePage_default_19 from '/app/src/pages/app/feedback/dashboard/rca.vue?definePage&vue'
import _definePage_default_20 from '/app/src/pages/app/feedback/dashboard/ticket.vue?definePage&vue'
import _definePage_default_21 from '/app/src/pages/app/feedback/dashboard/unit/index.vue?definePage&vue'
import _definePage_default_22 from '/app/src/pages/app/feedback/entry/index.vue?definePage&vue'
import _definePage_default_23 from '/app/src/pages/app/feedback/entry/ward-round.vue?definePage&vue'
import _definePage_default_24 from '/app/src/pages/app/feedback/entry/ward-round-v2.vue?definePage&vue'
import _definePage_default_25 from '/app/src/pages/app/feedback/episode.vue?definePage&vue'
import _definePage_default_26 from '/app/src/pages/app/feedback/feedback-history.vue?definePage&vue'
import _definePage_default_27 from '/app/src/pages/app/feedback/feedback-panel.vue?definePage&vue'
import _definePage_default_28 from '/app/src/pages/app/feedback/master/category.vue?definePage&vue'
import _definePage_default_29 from '/app/src/pages/app/feedback/master/config.vue?definePage&vue'
import _definePage_default_30 from '/app/src/pages/app/feedback/master/form-type.vue?definePage&vue'
import _definePage_default_31 from '/app/src/pages/app/feedback/master/source.vue?definePage&vue'
import _definePage_default_32 from '/app/src/pages/app/feedback/master/tag.vue?definePage&vue'
import _definePage_default_33 from '/app/src/pages/app/feedback/master/team.vue?definePage&vue'
import _definePage_default_34 from '/app/src/pages/app/feedback/not-authorized.vue?definePage&vue'
import _definePage_default_35 from '/app/src/pages/app/feedback/preference/index.vue?definePage&vue'
import _definePage_default_36 from '/app/src/pages/app/feedback/preference/[id].vue?definePage&vue'
import _definePage_default_37 from '/app/src/pages/app/feedback/questionnaire/index.vue?definePage&vue'
import _definePage_default_38 from '/app/src/pages/app/feedback/questionnaire/group.vue?definePage&vue'
import _definePage_default_39 from '/app/src/pages/app/feedback/second-page.vue?definePage&vue'
import _definePage_default_40 from '/app/src/pages/app/feedback/ticket-management/index.vue?definePage&vue'
import _definePage_default_41 from '/app/src/pages/app/feedback/ticket-management/board.vue?definePage&vue'
import _definePage_default_42 from '/app/src/pages/app/feedback/ticket-management/compliment.vue?definePage&vue'
import _definePage_default_43 from '/app/src/pages/app/feedback/utility/qrcode.vue?definePage&vue'
import _definePage_default_44 from '/app/src/pages/app/ForgotPassword.vue?definePage&vue'
import _definePage_default_45 from '/app/src/pages/app/global/config/index.vue?definePage&vue'
import _definePage_default_46 from '/app/src/pages/app/global/escalation/index.vue?definePage&vue'
import _definePage_default_47 from '/app/src/pages/app/global/holiday-calender/index.vue?definePage&vue'
import _definePage_default_48 from '/app/src/pages/app/global/master/department.vue?definePage&vue'
import _definePage_default_49 from '/app/src/pages/app/global/master/location.vue?definePage&vue'
import _definePage_default_50 from '/app/src/pages/app/global/master/location-type.vue?definePage&vue'
import _definePage_default_51 from '/app/src/pages/app/global/master/unit.vue?definePage&vue'
import _definePage_default_52 from '/app/src/pages/app/global/template-x/email.vue?definePage&vue'
import _definePage_default_53 from '/app/src/pages/app/global/template-x/sms.vue?definePage&vue'
import _definePage_default_54 from '/app/src/pages/app/global/template-x/whatsapp.vue?definePage&vue'
import _definePage_default_55 from '/app/src/pages/app/global/users/index.vue?definePage&vue'
import _definePage_default_56 from '/app/src/pages/app/login.vue?definePage&vue'
import _definePage_default_57 from '/app/src/pages/app/not-authorized.vue?definePage&vue'
import _definePage_default_58 from '/app/src/pages/app/panel.vue?definePage&vue'
import _definePage_default_59 from '/app/src/pages/app/quality/audit/collect.vue?definePage&vue'
import _definePage_default_60 from '/app/src/pages/app/quality/audit/dashboard.vue?definePage&vue'
import _definePage_default_61 from '/app/src/pages/app/quality/audit/reporting.vue?definePage&vue'
import _definePage_default_62 from '/app/src/pages/app/quality/audit/schedule.vue?definePage&vue'
import _definePage_default_63 from '/app/src/pages/app/quality/audit/view.vue?definePage&vue'
import _definePage_default_64 from '/app/src/pages/app/quality/capa/index.vue?definePage&vue'
import _definePage_default_65 from '/app/src/pages/app/quality/capa-calender.vue?definePage&vue'
import _definePage_default_66 from '/app/src/pages/app/quality/committee/index.vue?definePage&vue'
import _definePage_default_67 from '/app/src/pages/app/quality/committee/[id].vue?definePage&vue'
import _definePage_default_68 from '/app/src/pages/app/quality/committee/actions/index.vue?definePage&vue'
import _definePage_default_69 from '/app/src/pages/app/quality/committee/masters/types.vue?definePage&vue'
import _definePage_default_70 from '/app/src/pages/app/quality/committee/meetings/index.vue?definePage&vue'
import _definePage_default_71 from '/app/src/pages/app/quality/committee/meetings/[id].vue?definePage&vue'
import _definePage_default_72 from '/app/src/pages/app/quality/dashboard/index.vue?definePage&vue'
import _definePage_default_73 from '/app/src/pages/app/quality/document/index.vue?definePage&vue'
import _definePage_default_74 from '/app/src/pages/app/quality/document/[id].vue?definePage&vue'
import _definePage_default_75 from '/app/src/pages/app/quality/document/archive.vue?definePage&vue'
import _definePage_default_76 from '/app/src/pages/app/quality/document/masters/categories.vue?definePage&vue'
import _definePage_default_77 from '/app/src/pages/app/quality/document/masters/types.vue?definePage&vue'
import _definePage_default_78 from '/app/src/pages/app/quality/document/retention.vue?definePage&vue'
import _definePage_default_79 from '/app/src/pages/app/quality/incident/index.vue?definePage&vue'
import _definePage_default_80 from '/app/src/pages/app/quality/incident/entry/index.vue?definePage&vue'
import _definePage_default_81 from '/app/src/pages/app/quality/incident/entry/view.vue?definePage&vue'
import _definePage_default_82 from '/app/src/pages/app/quality/infection-control/antibiotic/index.vue?definePage&vue'
import _definePage_default_83 from '/app/src/pages/app/quality/infection-control/antibiotic/request/[id].vue?definePage&vue'
import _definePage_default_84 from '/app/src/pages/app/quality/infection-control/dashboard/index.vue?definePage&vue'
import _definePage_default_85 from '/app/src/pages/app/quality/infection-control/denominator/index.vue?definePage&vue'
import _definePage_default_86 from '/app/src/pages/app/quality/infection-control/exposure/index.vue?definePage&vue'
import _definePage_default_87 from '/app/src/pages/app/quality/infection-control/exposure/[id].vue?definePage&vue'
import _definePage_default_88 from '/app/src/pages/app/quality/infection-control/hai/index.vue?definePage&vue'
import _definePage_default_89 from '/app/src/pages/app/quality/infection-control/hai/entry/index.vue?definePage&vue'
import _definePage_default_90 from '/app/src/pages/app/quality/infection-control/hai/view.vue?definePage&vue'
import _definePage_default_91 from '/app/src/pages/app/quality/infection-control/isolation/index.vue?definePage&vue'
import _definePage_default_92 from '/app/src/pages/app/quality/infection-control/outbreak/index.vue?definePage&vue'
import _definePage_default_93 from '/app/src/pages/app/quality/infection-control/outbreak/view.vue?definePage&vue'
import _definePage_default_94 from '/app/src/pages/app/quality/kpi-metric/index.vue?definePage&vue'
import _definePage_default_95 from '/app/src/pages/app/quality/kpi-report/index.vue?definePage&vue'
import _definePage_default_96 from '/app/src/pages/app/quality/master/antibiotic.vue?definePage&vue'
import _definePage_default_97 from '/app/src/pages/app/quality/master/audit/index.vue?definePage&vue'
import _definePage_default_98 from '/app/src/pages/app/quality/master/audit/setup.vue?definePage&vue'
import _definePage_default_99 from '/app/src/pages/app/quality/master/category.vue?definePage&vue'
import _definePage_default_100 from '/app/src/pages/app/quality/master/contributory-factor.vue?definePage&vue'
import _definePage_default_101 from '/app/src/pages/app/quality/master/fishbone-category.vue?definePage&vue'
import _definePage_default_102 from '/app/src/pages/app/quality/master/hai-criteria/index.vue?definePage&vue'
import _definePage_default_103 from '/app/src/pages/app/quality/master/investigation-group.vue?definePage&vue'
import _definePage_default_104 from '/app/src/pages/app/quality/master/kpi-configuration/index.vue?definePage&vue'
import _definePage_default_105 from '/app/src/pages/app/quality/master/kpi-metric/index.vue?definePage&vue'
import _definePage_default_106 from '/app/src/pages/app/quality/master/organism.vue?definePage&vue'
import _definePage_default_107 from '/app/src/pages/app/quality/master/procedure-type.vue?definePage&vue'
import _definePage_default_108 from '/app/src/pages/app/quality/master/question/index.vue?definePage&vue'
import _definePage_default_109 from '/app/src/pages/app/quality/master/question/entry.vue?definePage&vue'
import _definePage_default_110 from '/app/src/pages/app/quality/master/tag.vue?definePage&vue'
import _definePage_default_111 from '/app/src/pages/app/quality/master/type.vue?definePage&vue'
import _definePage_default_112 from '/app/src/pages/app/quality/rca/index.vue?definePage&vue'
import _definePage_default_113 from '/app/src/pages/app/quality/rca/view.vue?definePage&vue'
import _definePage_default_114 from '/app/src/pages/app/quality/risk/index.vue?definePage&vue'
import _definePage_default_115 from '/app/src/pages/app/quality/risk/[id].vue?definePage&vue'
import _definePage_default_116 from '/app/src/pages/app/quality/risk/assessments/index.vue?definePage&vue'
import _definePage_default_117 from '/app/src/pages/app/quality/risk/assessments/[id].vue?definePage&vue'
import _definePage_default_118 from '/app/src/pages/app/quality/risk/dashboard.vue?definePage&vue'
import _definePage_default_119 from '/app/src/pages/app/quality/risk/governance.vue?definePage&vue'
import _definePage_default_120 from '/app/src/pages/app/quality/risk/masters/matrix.vue?definePage&vue'
import _definePage_default_121 from '/app/src/pages/app/quality/risk/masters/types/index.vue?definePage&vue'
import _definePage_default_122 from '/app/src/pages/app/quality/risk/masters/types/setup.vue?definePage&vue'
import _definePage_default_123 from '/app/src/pages/app/ResetPassword.vue?definePage&vue'
import _definePage_default_124 from '/app/src/pages/app/service-desk/dashboard.vue?definePage&vue'
import _definePage_default_125 from '/app/src/pages/app/service-desk/master/task.vue?definePage&vue'
import _definePage_default_126 from '/app/src/pages/app/service-desk/ticket-management/index.vue?definePage&vue'
import _definePage_default_127 from '/app/src/pages/app/service-desk/utility/qrcode.vue?definePage&vue'
import _definePage_default_128 from '/app/src/pages/app/survey/collection/customer/index.vue?definePage&vue'
import _definePage_default_129 from '/app/src/pages/app/survey/collection/customer/view.vue?definePage&vue'
import _definePage_default_130 from '/app/src/pages/app/survey/collection/view.vue?definePage&vue'
import _definePage_default_131 from '/app/src/pages/app/survey/customer/index.vue?definePage&vue'
import _definePage_default_132 from '/app/src/pages/app/survey/customer/analytics.vue?definePage&vue'
import _definePage_default_133 from '/app/src/pages/app/survey/customer/setup.vue?definePage&vue'
import _definePage_default_134 from '/app/src/pages/app/survey/customer/subscriptions.vue?definePage&vue'
import _definePage_default_135 from '/app/src/pages/app/survey/dashboard/index.vue?definePage&vue'
import _definePage_default_136 from '/app/src/pages/app/survey/employee/index.vue?definePage&vue'
import _definePage_default_137 from '/app/src/pages/app/survey/event/index.vue?definePage&vue'
import _definePage_default_138 from '/app/src/pages/app/survey/ticket-management/index.vue?definePage&vue'
import _definePage_default_139 from '/app/src/pages/app/two-step.vue?definePage&vue'
import _definePage_default_140 from '/app/src/pages/care-visit/kiosk/check-in.vue?definePage&vue'
import _definePage_default_141 from '/app/src/pages/care-visit/kiosk/check-out.vue?definePage&vue'
import _definePage_default_142 from '/app/src/pages/care-visit/kiosk/panel.vue?definePage&vue'
import _definePage_default_143 from '/app/src/pages/care-visit/kiosk/registration.vue?definePage&vue'
import _definePage_default_144 from '/app/src/pages/care-visit/visitor/pass.vue?definePage&vue'
import _definePage_default_145 from '/app/src/pages/documentation/[...slug].vue?definePage&vue'
import _definePage_default_146 from '/app/src/pages/feedback-collect/index.vue?definePage&vue'
import _definePage_default_147 from '/app/src/pages/service-desk/index.vue?definePage&vue'
import _definePage_default_148 from '/app/src/pages/survey-collect/index.vue?definePage&vue'
import _definePage_default_149 from '/app/src/pages/visitor-registration/index.vue?definePage&vue'
import _definePage_default_150 from '/app/src/pages/wecarexm-ai/index.vue?definePage&vue'

export const routes = [
  {
    path: '/app',
    /* internal name: 'app' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: ':error(.*)',
        name: 'app$error',
        component: () => import('/app/src/pages/app/[...error].vue'),
        /* no children */
      },
  _definePage_default_0
  ),
      {
        path: 'care-visit',
        /* internal name: 'app-care-visit' */
        /* no component */
        children: [
          {
            path: 'analytics',
            /* internal name: 'app-care-visit-analytics' */
            /* no component */
            children: [
              {
                path: 'department',
                name: 'app-care-visit-analytics-department',
                component: () => import('/app/src/pages/app/care-visit/analytics/department.vue'),
                /* no children */
              },
              {
                path: 'peak-hours',
                name: 'app-care-visit-analytics-peak-hours',
                component: () => import('/app/src/pages/app/care-visit/analytics/peak-hours.vue'),
                /* no children */
              },
              {
                path: 'statistics',
                name: 'app-care-visit-analytics-statistics',
                component: () => import('/app/src/pages/app/care-visit/analytics/statistics.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'customers',
            /* internal name: 'app-care-visit-customers' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'app-care-visit-customers',
                component: () => import('/app/src/pages/app/care-visit/customers/index.vue'),
                /* no children */
              },
  _definePage_default_2
  )
            ],
          },
          {
            path: 'dashboard',
            /* internal name: 'app-care-visit-dashboard' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'app-care-visit-dashboard',
                component: () => import('/app/src/pages/app/care-visit/dashboard/index.vue'),
                /* no children */
              },
  _definePage_default_3
  ),
              {
                path: 'kiosk-analytics',
                name: 'app-care-visit-dashboard-kiosk-analytics',
                component: () => import('/app/src/pages/app/care-visit/dashboard/kiosk-analytics.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'kiosks',
            /* internal name: 'app-care-visit-kiosks' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'app-care-visit-kiosks',
                component: () => import('/app/src/pages/app/care-visit/kiosks/index.vue'),
                /* no children */
              },
  _definePage_default_4
  )
            ],
          },
          {
            path: 'locations',
            /* internal name: 'app-care-visit-locations' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'app-care-visit-locations',
                component: () => import('/app/src/pages/app/care-visit/locations/index.vue'),
                /* no children */
              },
  _definePage_default_5
  )
            ],
          },
          {
            path: 'reports',
            /* internal name: 'app-care-visit-reports' */
            /* no component */
            children: [
              {
                path: 'daily',
                name: 'app-care-visit-reports-daily',
                component: () => import('/app/src/pages/app/care-visit/reports/daily.vue'),
                /* no children */
              },
              {
                path: 'monthly',
                name: 'app-care-visit-reports-monthly',
                component: () => import('/app/src/pages/app/care-visit/reports/monthly.vue'),
                /* no children */
              },
              {
                path: 'weekly',
                name: 'app-care-visit-reports-weekly',
                component: () => import('/app/src/pages/app/care-visit/reports/weekly.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'rules',
            /* internal name: 'app-care-visit-rules' */
            /* no component */
            children: [
              {
                path: 'time',
                name: 'app-care-visit-rules-time',
                component: () => import('/app/src/pages/app/care-visit/rules/time.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'security',
            /* internal name: 'app-care-visit-security' */
            /* no component */
            children: [
              {
                path: 'access-logs',
                name: 'app-care-visit-security-access-logs',
                component: () => import('/app/src/pages/app/care-visit/security/access-logs.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'sessions',
            /* internal name: 'app-care-visit-sessions' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'app-care-visit-sessions',
                component: () => import('/app/src/pages/app/care-visit/sessions/index.vue'),
                /* no children */
              },
  _definePage_default_6
  ),
              {
                path: 'active',
                name: 'app-care-visit-sessions-active',
                component: () => import('/app/src/pages/app/care-visit/sessions/active.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'visiting-rules',
            /* internal name: 'app-care-visit-visiting-rules' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'app-care-visit-visiting-rules',
                component: () => import('/app/src/pages/app/care-visit/visiting-rules/index.vue'),
                /* no children */
              },
  _definePage_default_7
  )
            ],
          },
          {
            path: 'visitors',
            /* internal name: 'app-care-visit-visitors' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'app-care-visit-visitors',
                component: () => import('/app/src/pages/app/care-visit/visitors/index.vue'),
                /* no children */
              },
  _definePage_default_8
  ),
              {
                path: 'create',
                name: 'app-care-visit-visitors-create',
                component: () => import('/app/src/pages/app/care-visit/visitors/create.vue'),
                /* no children */
              },
              {
                path: 'edit',
                name: 'app-care-visit-visitors-edit',
                component: () => import('/app/src/pages/app/care-visit/visitors/edit.vue'),
                /* no children */
              },
              {
                path: 'index-',
                name: 'app-care-visit-visitors-index',
                component: () => import('/app/src/pages/app/care-visit/visitors/index-.vue'),
                /* no children */
              },
              {
                path: 'test',
                name: 'app-care-visit-visitors-test',
                component: () => import('/app/src/pages/app/care-visit/visitors/test.vue'),
                /* no children */
              },
              {
                path: 'view',
                name: 'app-care-visit-visitors-view',
                component: () => import('/app/src/pages/app/care-visit/visitors/view.vue'),
                /* no children */
              }
            ],
          }
        ],
      },
      {
        path: 'common',
        /* internal name: 'app-common' */
        /* no component */
        children: [
          {
            path: 'notifications',
            /* internal name: 'app-common-notifications' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'app-common-notifications',
                component: () => import('/app/src/pages/app/common/notifications/index.vue'),
                /* no children */
              },
  _definePage_default_9
  )
            ],
          }
        ],
      },
      {
        path: 'feedback',
        /* internal name: 'app-feedback' */
        /* no component */
        children: [
          {
            path: 'auth',
            /* internal name: 'app-feedback-auth' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: 'role',
                name: 'app-feedback-auth-role',
                component: () => import('/app/src/pages/app/feedback/auth/role.vue'),
                /* no children */
              },
  _definePage_default_10
  )
            ],
          },
  _mergeRouteRecord(
          {
            path: 'capa-management',
            name: 'app-feedback-capa-management',
            component: () => import('/app/src/pages/app/feedback/capa-management.vue'),
            /* no children */
          },
  _definePage_default_11
  ),
  _mergeRouteRecord(
          {
            path: 'customer-communication',
            name: 'app-feedback-customer-communication',
            component: () => import('/app/src/pages/app/feedback/customer-communication.vue'),
            /* no children */
          },
  _definePage_default_12
  ),
          {
            path: 'dashboard',
            /* internal name: 'app-feedback-dashboard' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'app-feedback-dashboard',
                component: () => import('/app/src/pages/app/feedback/dashboard/index.vue'),
                /* no children */
              },
  _definePage_default_13
  ),
  _mergeRouteRecord(
              {
                path: 'complaint',
                name: 'app-feedback-dashboard-complaint',
                component: () => import('/app/src/pages/app/feedback/dashboard/complaint.vue'),
                /* no children */
              },
  _definePage_default_14
  ),
              {
                path: 'department',
                /* internal name: 'app-feedback-dashboard-department' */
                /* no component */
                children: [
  _mergeRouteRecord(
                  {
                    path: '',
                    name: 'app-feedback-dashboard-department',
                    component: () => import('/app/src/pages/app/feedback/dashboard/department/index.vue'),
                    /* no children */
                  },
  _definePage_default_15
  )
                ],
              },
  _mergeRouteRecord(
              {
                path: 'feedback',
                name: 'app-feedback-dashboard-feedback',
                component: () => import('/app/src/pages/app/feedback/dashboard/feedback.vue'),
                /* no children */
              },
  _definePage_default_16
  ),
              {
                path: 'location',
                /* internal name: 'app-feedback-dashboard-location' */
                /* no component */
                children: [
  _mergeRouteRecord(
                  {
                    path: '',
                    name: 'app-feedback-dashboard-location',
                    component: () => import('/app/src/pages/app/feedback/dashboard/location/index.vue'),
                    /* no children */
                  },
  _definePage_default_17
  )
                ],
              },
              {
                path: 'question',
                /* internal name: 'app-feedback-dashboard-question' */
                /* no component */
                children: [
  _mergeRouteRecord(
                  {
                    path: '',
                    name: 'app-feedback-dashboard-question',
                    component: () => import('/app/src/pages/app/feedback/dashboard/question/index.vue'),
                    /* no children */
                  },
  _definePage_default_18
  )
                ],
              },
  _mergeRouteRecord(
              {
                path: 'rca',
                name: 'app-feedback-dashboard-rca',
                component: () => import('/app/src/pages/app/feedback/dashboard/rca.vue'),
                /* no children */
              },
  _definePage_default_19
  ),
  _mergeRouteRecord(
              {
                path: 'ticket',
                name: 'app-feedback-dashboard-ticket',
                component: () => import('/app/src/pages/app/feedback/dashboard/ticket.vue'),
                /* no children */
              },
  _definePage_default_20
  ),
              {
                path: 'unit',
                /* internal name: 'app-feedback-dashboard-unit' */
                /* no component */
                children: [
  _mergeRouteRecord(
                  {
                    path: '',
                    name: 'app-feedback-dashboard-unit',
                    component: () => import('/app/src/pages/app/feedback/dashboard/unit/index.vue'),
                    /* no children */
                  },
  _definePage_default_21
  )
                ],
              }
            ],
          },
          {
            path: 'empty',
            name: 'app-feedback-empty',
            component: () => import('/app/src/pages/app/feedback/empty.vue'),
            /* no children */
          },
          {
            path: 'entry',
            /* internal name: 'app-feedback-entry' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'app-feedback-entry',
                component: () => import('/app/src/pages/app/feedback/entry/index.vue'),
                /* no children */
              },
  _definePage_default_22
  ),
  _mergeRouteRecord(
              {
                path: 'ward-round',
                name: 'app-feedback-entry-ward-round',
                component: () => import('/app/src/pages/app/feedback/entry/ward-round.vue'),
                /* no children */
              },
  _definePage_default_23
  ),
  _mergeRouteRecord(
              {
                path: 'ward-round-v2',
                name: 'app-feedback-entry-ward-round-v2',
                component: () => import('/app/src/pages/app/feedback/entry/ward-round-v2.vue'),
                /* no children */
              },
  _definePage_default_24
  )
            ],
          },
  _mergeRouteRecord(
          {
            path: 'episode',
            name: 'app-feedback-episode',
            component: () => import('/app/src/pages/app/feedback/episode.vue'),
            /* no children */
          },
  _definePage_default_25
  ),
  _mergeRouteRecord(
          {
            path: 'feedback-history',
            name: 'app-feedback-feedback-history',
            component: () => import('/app/src/pages/app/feedback/feedback-history.vue'),
            /* no children */
          },
  _definePage_default_26
  ),
  _mergeRouteRecord(
          {
            path: 'feedback-panel',
            name: 'app-feedback-feedback-panel',
            component: () => import('/app/src/pages/app/feedback/feedback-panel.vue'),
            /* no children */
          },
  _definePage_default_27
  ),
          {
            path: 'master',
            /* internal name: 'app-feedback-master' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: 'category',
                name: 'app-feedback-master-category',
                component: () => import('/app/src/pages/app/feedback/master/category.vue'),
                /* no children */
              },
  _definePage_default_28
  ),
  _mergeRouteRecord(
              {
                path: 'config',
                name: 'app-feedback-master-config',
                component: () => import('/app/src/pages/app/feedback/master/config.vue'),
                /* no children */
              },
  _definePage_default_29
  ),
  _mergeRouteRecord(
              {
                path: 'form-type',
                name: 'app-feedback-master-form-type',
                component: () => import('/app/src/pages/app/feedback/master/form-type.vue'),
                /* no children */
              },
  _definePage_default_30
  ),
  _mergeRouteRecord(
              {
                path: 'source',
                name: 'app-feedback-master-source',
                component: () => import('/app/src/pages/app/feedback/master/source.vue'),
                /* no children */
              },
  _definePage_default_31
  ),
  _mergeRouteRecord(
              {
                path: 'tag',
                name: 'app-feedback-master-tag',
                component: () => import('/app/src/pages/app/feedback/master/tag.vue'),
                /* no children */
              },
  _definePage_default_32
  ),
  _mergeRouteRecord(
              {
                path: 'team',
                name: 'app-feedback-master-team',
                component: () => import('/app/src/pages/app/feedback/master/team.vue'),
                /* no children */
              },
  _definePage_default_33
  )
            ],
          },
  _mergeRouteRecord(
          {
            path: 'not-authorized',
            name: 'app-feedback-not-authorized',
            component: () => import('/app/src/pages/app/feedback/not-authorized.vue'),
            /* no children */
          },
  _definePage_default_34
  ),
          {
            path: 'preference',
            /* internal name: 'app-feedback-preference' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'app-feedback-preference',
                component: () => import('/app/src/pages/app/feedback/preference/index.vue'),
                /* no children */
              },
  _definePage_default_35
  ),
  _mergeRouteRecord(
              {
                path: ':id',
                name: 'app-feedback-preference-id',
                component: () => import('/app/src/pages/app/feedback/preference/[id].vue'),
                /* no children */
              },
  _definePage_default_36
  )
            ],
          },
          {
            path: 'questionnaire',
            /* internal name: 'app-feedback-questionnaire' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'app-feedback-questionnaire',
                component: () => import('/app/src/pages/app/feedback/questionnaire/index.vue'),
                /* no children */
              },
  _definePage_default_37
  ),
  _mergeRouteRecord(
              {
                path: 'group',
                name: 'app-feedback-questionnaire-group',
                component: () => import('/app/src/pages/app/feedback/questionnaire/group.vue'),
                /* no children */
              },
  _definePage_default_38
  ),
              {
                path: 'question',
                name: 'app-feedback-questionnaire-question',
                component: () => import('/app/src/pages/app/feedback/questionnaire/question.vue'),
                /* no children */
              }
            ],
          },
  _mergeRouteRecord(
          {
            path: 'second-page',
            name: 'app-feedback-second-page',
            component: () => import('/app/src/pages/app/feedback/second-page.vue'),
            /* no children */
          },
  _definePage_default_39
  ),
          {
            path: 'ticket-management',
            /* internal name: 'app-feedback-ticket-management' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'app-feedback-ticket-management',
                component: () => import('/app/src/pages/app/feedback/ticket-management/index.vue'),
                /* no children */
              },
  _definePage_default_40
  ),
  _mergeRouteRecord(
              {
                path: 'board',
                name: 'app-feedback-ticket-management-board',
                component: () => import('/app/src/pages/app/feedback/ticket-management/board.vue'),
                /* no children */
              },
  _definePage_default_41
  ),
  _mergeRouteRecord(
              {
                path: 'compliment',
                name: 'app-feedback-ticket-management-compliment',
                component: () => import('/app/src/pages/app/feedback/ticket-management/compliment.vue'),
                /* no children */
              },
  _definePage_default_42
  )
            ],
          },
          {
            path: 'utility',
            /* internal name: 'app-feedback-utility' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: 'qrcode',
                name: 'app-feedback-utility-qrcode',
                component: () => import('/app/src/pages/app/feedback/utility/qrcode.vue'),
                /* no children */
              },
  _definePage_default_43
  )
            ],
          }
        ],
      },
  _mergeRouteRecord(
      {
        path: 'ForgotPassword',
        name: 'app-forgot-password',
        component: () => import('/app/src/pages/app/ForgotPassword.vue'),
        /* no children */
      },
  _definePage_default_44
  ),
      {
        path: 'global',
        /* internal name: 'app-global' */
        /* no component */
        children: [
          {
            path: 'config',
            /* internal name: 'app-global-config' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'app-global-config',
                component: () => import('/app/src/pages/app/global/config/index.vue'),
                /* no children */
              },
  _definePage_default_45
  ),
              {
                path: 'config',
                name: 'app-global-config-config',
                component: () => import('/app/src/pages/app/global/config/config.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'escalation',
            /* internal name: 'app-global-escalation' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'app-global-escalation',
                component: () => import('/app/src/pages/app/global/escalation/index.vue'),
                /* no children */
              },
  _definePage_default_46
  ),
              {
                path: 'create-update',
                name: 'app-global-escalation-create-update',
                component: () => import('/app/src/pages/app/global/escalation/create-update.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'holiday-calender',
            /* internal name: 'app-global-holiday-calender' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'app-global-holiday-calender',
                component: () => import('/app/src/pages/app/global/holiday-calender/index.vue'),
                /* no children */
              },
  _definePage_default_47
  )
            ],
          },
          {
            path: 'master',
            /* internal name: 'app-global-master' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: 'department',
                name: 'app-global-master-department',
                component: () => import('/app/src/pages/app/global/master/department.vue'),
                /* no children */
              },
  _definePage_default_48
  ),
  _mergeRouteRecord(
              {
                path: 'location',
                name: 'app-global-master-location',
                component: () => import('/app/src/pages/app/global/master/location.vue'),
                /* no children */
              },
  _definePage_default_49
  ),
  _mergeRouteRecord(
              {
                path: 'location-type',
                name: 'app-global-master-location-type',
                component: () => import('/app/src/pages/app/global/master/location-type.vue'),
                /* no children */
              },
  _definePage_default_50
  ),
  _mergeRouteRecord(
              {
                path: 'unit',
                name: 'app-global-master-unit',
                component: () => import('/app/src/pages/app/global/master/unit.vue'),
                /* no children */
              },
  _definePage_default_51
  )
            ],
          },
          {
            path: 'notification-configuration',
            /* internal name: 'app-global-notification-configuration' */
            /* no component */
            children: [
              {
                path: '',
                name: 'app-global-notification-configuration',
                component: () => import('/app/src/pages/app/global/notification-configuration/index.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'template-x',
            /* internal name: 'app-global-template-x' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: 'email',
                name: 'app-global-template-xemail',
                component: () => import('/app/src/pages/app/global/template-x/email.vue'),
                /* no children */
              },
  _definePage_default_52
  ),
  _mergeRouteRecord(
              {
                path: 'sms',
                name: 'app-global-template-xsms',
                component: () => import('/app/src/pages/app/global/template-x/sms.vue'),
                /* no children */
              },
  _definePage_default_53
  ),
  _mergeRouteRecord(
              {
                path: 'whatsapp',
                name: 'app-global-template-xwhatsapp',
                component: () => import('/app/src/pages/app/global/template-x/whatsapp.vue'),
                /* no children */
              },
  _definePage_default_54
  )
            ],
          },
          {
            path: 'users',
            /* internal name: 'app-global-users' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'app-global-users',
                component: () => import('/app/src/pages/app/global/users/index.vue'),
                /* no children */
              },
  _definePage_default_55
  ),
              {
                path: 'user',
                name: 'app-global-users-user',
                component: () => import('/app/src/pages/app/global/users/user.vue'),
                /* no children */
              }
            ],
          }
        ],
      },
  _mergeRouteRecord(
      {
        path: 'login',
        name: 'app-login',
        component: () => import('/app/src/pages/app/login.vue'),
        /* no children */
      },
  _definePage_default_56
  ),
  _mergeRouteRecord(
      {
        path: 'not-authorized',
        name: 'app-not-authorized',
        component: () => import('/app/src/pages/app/not-authorized.vue'),
        /* no children */
      },
  _definePage_default_57
  ),
  _mergeRouteRecord(
      {
        path: 'panel',
        name: 'app-panel',
        component: () => import('/app/src/pages/app/panel.vue'),
        /* no children */
      },
  _definePage_default_58
  ),
      {
        path: 'quality',
        /* internal name: 'app-quality' */
        /* no component */
        children: [
          {
            path: 'audit',
            /* internal name: 'app-quality-audit' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: 'collect',
                name: 'app-quality-audit-collect',
                component: () => import('/app/src/pages/app/quality/audit/collect.vue'),
                /* no children */
              },
  _definePage_default_59
  ),
  _mergeRouteRecord(
              {
                path: 'dashboard',
                name: 'app-quality-audit-dashboard',
                component: () => import('/app/src/pages/app/quality/audit/dashboard.vue'),
                /* no children */
              },
  _definePage_default_60
  ),
  _mergeRouteRecord(
              {
                path: 'reporting',
                name: 'app-quality-audit-reporting',
                component: () => import('/app/src/pages/app/quality/audit/reporting.vue'),
                /* no children */
              },
  _definePage_default_61
  ),
  _mergeRouteRecord(
              {
                path: 'schedule',
                name: 'app-quality-audit-schedule',
                component: () => import('/app/src/pages/app/quality/audit/schedule.vue'),
                /* no children */
              },
  _definePage_default_62
  ),
  _mergeRouteRecord(
              {
                path: 'view',
                name: 'app-quality-audit-view',
                component: () => import('/app/src/pages/app/quality/audit/view.vue'),
                /* no children */
              },
  _definePage_default_63
  )
            ],
          },
          {
            path: 'capa',
            /* internal name: 'app-quality-capa' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'app-quality-capa',
                component: () => import('/app/src/pages/app/quality/capa/index.vue'),
                /* no children */
              },
  _definePage_default_64
  )
            ],
          },
  _mergeRouteRecord(
          {
            path: 'capa-calender',
            name: 'app-quality-capa-calender',
            component: () => import('/app/src/pages/app/quality/capa-calender.vue'),
            /* no children */
          },
  _definePage_default_65
  ),
          {
            path: 'committee',
            /* internal name: 'app-quality-committee' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'app-quality-committee',
                component: () => import('/app/src/pages/app/quality/committee/index.vue'),
                /* no children */
              },
  _definePage_default_66
  ),
  _mergeRouteRecord(
              {
                path: ':id',
                name: 'app-quality-committee-id',
                component: () => import('/app/src/pages/app/quality/committee/[id].vue'),
                /* no children */
              },
  _definePage_default_67
  ),
              {
                path: 'actions',
                /* internal name: 'app-quality-committee-actions' */
                /* no component */
                children: [
  _mergeRouteRecord(
                  {
                    path: '',
                    name: 'app-quality-committee-actions',
                    component: () => import('/app/src/pages/app/quality/committee/actions/index.vue'),
                    /* no children */
                  },
  _definePage_default_68
  )
                ],
              },
              {
                path: 'masters',
                /* internal name: 'app-quality-committee-masters' */
                /* no component */
                children: [
  _mergeRouteRecord(
                  {
                    path: 'types',
                    name: 'app-quality-committee-masters-types',
                    component: () => import('/app/src/pages/app/quality/committee/masters/types.vue'),
                    /* no children */
                  },
  _definePage_default_69
  )
                ],
              },
              {
                path: 'meetings',
                /* internal name: 'app-quality-committee-meetings' */
                /* no component */
                children: [
  _mergeRouteRecord(
                  {
                    path: '',
                    name: 'app-quality-committee-meetings',
                    component: () => import('/app/src/pages/app/quality/committee/meetings/index.vue'),
                    /* no children */
                  },
  _definePage_default_70
  ),
  _mergeRouteRecord(
                  {
                    path: ':id',
                    name: 'app-quality-committee-meetings-id',
                    component: () => import('/app/src/pages/app/quality/committee/meetings/[id].vue'),
                    /* no children */
                  },
  _definePage_default_71
  )
                ],
              }
            ],
          },
          {
            path: 'dashboard',
            /* internal name: 'app-quality-dashboard' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'app-quality-dashboard',
                component: () => import('/app/src/pages/app/quality/dashboard/index.vue'),
                /* no children */
              },
  _definePage_default_72
  )
            ],
          },
          {
            path: 'document',
            /* internal name: 'app-quality-document' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'app-quality-document',
                component: () => import('/app/src/pages/app/quality/document/index.vue'),
                /* no children */
              },
  _definePage_default_73
  ),
  _mergeRouteRecord(
              {
                path: ':id',
                name: 'app-quality-document-id',
                component: () => import('/app/src/pages/app/quality/document/[id].vue'),
                /* no children */
              },
  _definePage_default_74
  ),
  _mergeRouteRecord(
              {
                path: 'archive',
                name: 'app-quality-document-archive',
                component: () => import('/app/src/pages/app/quality/document/archive.vue'),
                /* no children */
              },
  _definePage_default_75
  ),
              {
                path: 'masters',
                /* internal name: 'app-quality-document-masters' */
                /* no component */
                children: [
  _mergeRouteRecord(
                  {
                    path: 'categories',
                    name: 'app-quality-document-masters-categories',
                    component: () => import('/app/src/pages/app/quality/document/masters/categories.vue'),
                    /* no children */
                  },
  _definePage_default_76
  ),
  _mergeRouteRecord(
                  {
                    path: 'types',
                    name: 'app-quality-document-masters-types',
                    component: () => import('/app/src/pages/app/quality/document/masters/types.vue'),
                    /* no children */
                  },
  _definePage_default_77
  )
                ],
              },
  _mergeRouteRecord(
              {
                path: 'retention',
                name: 'app-quality-document-retention',
                component: () => import('/app/src/pages/app/quality/document/retention.vue'),
                /* no children */
              },
  _definePage_default_78
  )
            ],
          },
          {
            path: 'incident',
            /* internal name: 'app-quality-incident' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'app-quality-incident',
                component: () => import('/app/src/pages/app/quality/incident/index.vue'),
                /* no children */
              },
  _definePage_default_79
  ),
              {
                path: 'entry',
                /* internal name: 'app-quality-incident-entry' */
                /* no component */
                children: [
  _mergeRouteRecord(
                  {
                    path: '',
                    name: 'app-quality-incident-entry',
                    component: () => import('/app/src/pages/app/quality/incident/entry/index.vue'),
                    /* no children */
                  },
  _definePage_default_80
  ),
  _mergeRouteRecord(
                  {
                    path: 'view',
                    name: 'app-quality-incident-entry-view',
                    component: () => import('/app/src/pages/app/quality/incident/entry/view.vue'),
                    /* no children */
                  },
  _definePage_default_81
  )
                ],
              }
            ],
          },
          {
            path: 'infection-control',
            /* internal name: 'app-quality-infection-control' */
            /* no component */
            children: [
              {
                path: 'antibiotic',
                /* internal name: 'app-quality-infection-control-antibiotic' */
                /* no component */
                children: [
  _mergeRouteRecord(
                  {
                    path: '',
                    name: 'app-quality-infection-control-antibiotic',
                    component: () => import('/app/src/pages/app/quality/infection-control/antibiotic/index.vue'),
                    /* no children */
                  },
  _definePage_default_82
  ),
                  {
                    path: 'request',
                    /* internal name: 'app-quality-infection-control-antibiotic-request' */
                    /* no component */
                    children: [
  _mergeRouteRecord(
                      {
                        path: ':id',
                        name: 'app-quality-infection-control-antibiotic-request-id',
                        component: () => import('/app/src/pages/app/quality/infection-control/antibiotic/request/[id].vue'),
                        /* no children */
                      },
  _definePage_default_83
  )
                    ],
                  }
                ],
              },
              {
                path: 'dashboard',
                /* internal name: 'app-quality-infection-control-dashboard' */
                /* no component */
                children: [
  _mergeRouteRecord(
                  {
                    path: '',
                    name: 'app-quality-infection-control-dashboard',
                    component: () => import('/app/src/pages/app/quality/infection-control/dashboard/index.vue'),
                    /* no children */
                  },
  _definePage_default_84
  )
                ],
              },
              {
                path: 'denominator',
                /* internal name: 'app-quality-infection-control-denominator' */
                /* no component */
                children: [
  _mergeRouteRecord(
                  {
                    path: '',
                    name: 'app-quality-infection-control-denominator',
                    component: () => import('/app/src/pages/app/quality/infection-control/denominator/index.vue'),
                    /* no children */
                  },
  _definePage_default_85
  )
                ],
              },
              {
                path: 'exposure',
                /* internal name: 'app-quality-infection-control-exposure' */
                /* no component */
                children: [
  _mergeRouteRecord(
                  {
                    path: '',
                    name: 'app-quality-infection-control-exposure',
                    component: () => import('/app/src/pages/app/quality/infection-control/exposure/index.vue'),
                    /* no children */
                  },
  _definePage_default_86
  ),
  _mergeRouteRecord(
                  {
                    path: ':id',
                    name: 'app-quality-infection-control-exposure-id',
                    component: () => import('/app/src/pages/app/quality/infection-control/exposure/[id].vue'),
                    /* no children */
                  },
  _definePage_default_87
  )
                ],
              },
              {
                path: 'hai',
                /* internal name: 'app-quality-infection-control-hai' */
                /* no component */
                children: [
  _mergeRouteRecord(
                  {
                    path: '',
                    name: 'app-quality-infection-control-hai',
                    component: () => import('/app/src/pages/app/quality/infection-control/hai/index.vue'),
                    /* no children */
                  },
  _definePage_default_88
  ),
                  {
                    path: 'entry',
                    /* internal name: 'app-quality-infection-control-hai-entry' */
                    /* no component */
                    children: [
  _mergeRouteRecord(
                      {
                        path: '',
                        name: 'app-quality-infection-control-hai-entry',
                        component: () => import('/app/src/pages/app/quality/infection-control/hai/entry/index.vue'),
                        /* no children */
                      },
  _definePage_default_89
  )
                    ],
                  },
  _mergeRouteRecord(
                  {
                    path: 'view',
                    name: 'app-quality-infection-control-hai-view',
                    component: () => import('/app/src/pages/app/quality/infection-control/hai/view.vue'),
                    /* no children */
                  },
  _definePage_default_90
  )
                ],
              },
              {
                path: 'isolation',
                /* internal name: 'app-quality-infection-control-isolation' */
                /* no component */
                children: [
  _mergeRouteRecord(
                  {
                    path: '',
                    name: 'app-quality-infection-control-isolation',
                    component: () => import('/app/src/pages/app/quality/infection-control/isolation/index.vue'),
                    /* no children */
                  },
  _definePage_default_91
  )
                ],
              },
              {
                path: 'outbreak',
                /* internal name: 'app-quality-infection-control-outbreak' */
                /* no component */
                children: [
  _mergeRouteRecord(
                  {
                    path: '',
                    name: 'app-quality-infection-control-outbreak',
                    component: () => import('/app/src/pages/app/quality/infection-control/outbreak/index.vue'),
                    /* no children */
                  },
  _definePage_default_92
  ),
  _mergeRouteRecord(
                  {
                    path: 'view',
                    name: 'app-quality-infection-control-outbreak-view',
                    component: () => import('/app/src/pages/app/quality/infection-control/outbreak/view.vue'),
                    /* no children */
                  },
  _definePage_default_93
  )
                ],
              }
            ],
          },
          {
            path: 'kpi-metric',
            /* internal name: 'app-quality-kpi-metric' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'app-quality-kpi-metric',
                component: () => import('/app/src/pages/app/quality/kpi-metric/index.vue'),
                /* no children */
              },
  _definePage_default_94
  ),
              {
                path: 'collect',
                name: 'app-quality-kpi-metric-collect',
                component: () => import('/app/src/pages/app/quality/kpi-metric/collect.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'kpi-report',
            /* internal name: 'app-quality-kpi-report' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'app-quality-kpi-report',
                component: () => import('/app/src/pages/app/quality/kpi-report/index.vue'),
                /* no children */
              },
  _definePage_default_95
  )
            ],
          },
          {
            path: 'master',
            /* internal name: 'app-quality-master' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: 'antibiotic',
                name: 'app-quality-master-antibiotic',
                component: () => import('/app/src/pages/app/quality/master/antibiotic.vue'),
                /* no children */
              },
  _definePage_default_96
  ),
              {
                path: 'audit',
                /* internal name: 'app-quality-master-audit' */
                /* no component */
                children: [
  _mergeRouteRecord(
                  {
                    path: '',
                    name: 'app-quality-master-audit',
                    component: () => import('/app/src/pages/app/quality/master/audit/index.vue'),
                    /* no children */
                  },
  _definePage_default_97
  ),
  _mergeRouteRecord(
                  {
                    path: 'setup',
                    name: 'app-quality-master-audit-setup',
                    component: () => import('/app/src/pages/app/quality/master/audit/setup.vue'),
                    /* no children */
                  },
  _definePage_default_98
  )
                ],
              },
  _mergeRouteRecord(
              {
                path: 'category',
                name: 'app-quality-master-category',
                component: () => import('/app/src/pages/app/quality/master/category.vue'),
                /* no children */
              },
  _definePage_default_99
  ),
  _mergeRouteRecord(
              {
                path: 'contributory-factor',
                name: 'app-quality-master-contributory-factor',
                component: () => import('/app/src/pages/app/quality/master/contributory-factor.vue'),
                /* no children */
              },
  _definePage_default_100
  ),
  _mergeRouteRecord(
              {
                path: 'fishbone-category',
                name: 'app-quality-master-fishbone-category',
                component: () => import('/app/src/pages/app/quality/master/fishbone-category.vue'),
                /* no children */
              },
  _definePage_default_101
  ),
              {
                path: 'hai-criteria',
                /* internal name: 'app-quality-master-hai-criteria' */
                /* no component */
                children: [
  _mergeRouteRecord(
                  {
                    path: '',
                    name: 'app-quality-master-hai-criteria',
                    component: () => import('/app/src/pages/app/quality/master/hai-criteria/index.vue'),
                    /* no children */
                  },
  _definePage_default_102
  )
                ],
              },
  _mergeRouteRecord(
              {
                path: 'investigation-group',
                name: 'app-quality-master-investigation-group',
                component: () => import('/app/src/pages/app/quality/master/investigation-group.vue'),
                /* no children */
              },
  _definePage_default_103
  ),
              {
                path: 'kpi-configuration',
                /* internal name: 'app-quality-master-kpi-configuration' */
                /* no component */
                children: [
  _mergeRouteRecord(
                  {
                    path: '',
                    name: 'app-quality-master-kpi-configuration',
                    component: () => import('/app/src/pages/app/quality/master/kpi-configuration/index.vue'),
                    /* no children */
                  },
  _definePage_default_104
  ),
                  {
                    path: 'setup',
                    name: 'app-quality-master-kpi-configuration-setup',
                    component: () => import('/app/src/pages/app/quality/master/kpi-configuration/setup.vue'),
                    /* no children */
                  }
                ],
              },
              {
                path: 'kpi-metric',
                /* internal name: 'app-quality-master-kpi-metric' */
                /* no component */
                children: [
  _mergeRouteRecord(
                  {
                    path: '',
                    name: 'app-quality-master-kpi-metric',
                    component: () => import('/app/src/pages/app/quality/master/kpi-metric/index.vue'),
                    /* no children */
                  },
  _definePage_default_105
  ),
                  {
                    path: 'setup',
                    name: 'app-quality-master-kpi-metric-setup',
                    component: () => import('/app/src/pages/app/quality/master/kpi-metric/setup.vue'),
                    /* no children */
                  }
                ],
              },
  _mergeRouteRecord(
              {
                path: 'organism',
                name: 'app-quality-master-organism',
                component: () => import('/app/src/pages/app/quality/master/organism.vue'),
                /* no children */
              },
  _definePage_default_106
  ),
  _mergeRouteRecord(
              {
                path: 'procedure-type',
                name: 'app-quality-master-procedure-type',
                component: () => import('/app/src/pages/app/quality/master/procedure-type.vue'),
                /* no children */
              },
  _definePage_default_107
  ),
              {
                path: 'question',
                /* internal name: 'app-quality-master-question' */
                /* no component */
                children: [
  _mergeRouteRecord(
                  {
                    path: '',
                    name: 'app-quality-master-question',
                    component: () => import('/app/src/pages/app/quality/master/question/index.vue'),
                    /* no children */
                  },
  _definePage_default_108
  ),
  _mergeRouteRecord(
                  {
                    path: 'entry',
                    name: 'app-quality-master-question-entry',
                    component: () => import('/app/src/pages/app/quality/master/question/entry.vue'),
                    /* no children */
                  },
  _definePage_default_109
  )
                ],
              },
  _mergeRouteRecord(
              {
                path: 'tag',
                name: 'app-quality-master-tag',
                component: () => import('/app/src/pages/app/quality/master/tag.vue'),
                /* no children */
              },
  _definePage_default_110
  ),
  _mergeRouteRecord(
              {
                path: 'type',
                name: 'app-quality-master-type',
                component: () => import('/app/src/pages/app/quality/master/type.vue'),
                /* no children */
              },
  _definePage_default_111
  )
            ],
          },
          {
            path: 'rca',
            /* internal name: 'app-quality-rca' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'app-quality-rca',
                component: () => import('/app/src/pages/app/quality/rca/index.vue'),
                /* no children */
              },
  _definePage_default_112
  ),
              {
                path: 'investigation',
                /* internal name: 'app-quality-rca-investigation' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: 'app-quality-rca-investigation',
                    component: () => import('/app/src/pages/app/quality/rca/investigation/index.vue'),
                    /* no children */
                  }
                ],
              },
  _mergeRouteRecord(
              {
                path: 'view',
                name: 'app-quality-rca-view',
                component: () => import('/app/src/pages/app/quality/rca/view.vue'),
                /* no children */
              },
  _definePage_default_113
  )
            ],
          },
          {
            path: 'risk',
            /* internal name: 'app-quality-risk' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'app-quality-risk',
                component: () => import('/app/src/pages/app/quality/risk/index.vue'),
                /* no children */
              },
  _definePage_default_114
  ),
  _mergeRouteRecord(
              {
                path: ':id',
                name: 'app-quality-risk-id',
                component: () => import('/app/src/pages/app/quality/risk/[id].vue'),
                /* no children */
              },
  _definePage_default_115
  ),
              {
                path: 'assessments',
                /* internal name: 'app-quality-risk-assessments' */
                /* no component */
                children: [
  _mergeRouteRecord(
                  {
                    path: '',
                    name: 'app-quality-risk-assessments',
                    component: () => import('/app/src/pages/app/quality/risk/assessments/index.vue'),
                    /* no children */
                  },
  _definePage_default_116
  ),
  _mergeRouteRecord(
                  {
                    path: ':id',
                    name: 'app-quality-risk-assessments-id',
                    component: () => import('/app/src/pages/app/quality/risk/assessments/[id].vue'),
                    /* no children */
                  },
  _definePage_default_117
  )
                ],
              },
  _mergeRouteRecord(
              {
                path: 'dashboard',
                name: 'app-quality-risk-dashboard',
                component: () => import('/app/src/pages/app/quality/risk/dashboard.vue'),
                /* no children */
              },
  _definePage_default_118
  ),
  _mergeRouteRecord(
              {
                path: 'governance',
                name: 'app-quality-risk-governance',
                component: () => import('/app/src/pages/app/quality/risk/governance.vue'),
                /* no children */
              },
  _definePage_default_119
  ),
              {
                path: 'masters',
                /* internal name: 'app-quality-risk-masters' */
                /* no component */
                children: [
  _mergeRouteRecord(
                  {
                    path: 'matrix',
                    name: 'app-quality-risk-masters-matrix',
                    component: () => import('/app/src/pages/app/quality/risk/masters/matrix.vue'),
                    /* no children */
                  },
  _definePage_default_120
  ),
                  {
                    path: 'types',
                    /* internal name: 'app-quality-risk-masters-types' */
                    /* no component */
                    children: [
  _mergeRouteRecord(
                      {
                        path: '',
                        name: 'app-quality-risk-masters-types',
                        component: () => import('/app/src/pages/app/quality/risk/masters/types/index.vue'),
                        /* no children */
                      },
  _definePage_default_121
  ),
  _mergeRouteRecord(
                      {
                        path: 'setup',
                        name: 'app-quality-risk-masters-types-setup',
                        component: () => import('/app/src/pages/app/quality/risk/masters/types/setup.vue'),
                        /* no children */
                      },
  _definePage_default_122
  )
                    ],
                  }
                ],
              }
            ],
          }
        ],
      },
  _mergeRouteRecord(
      {
        path: 'ResetPassword',
        name: 'app-reset-password',
        component: () => import('/app/src/pages/app/ResetPassword.vue'),
        /* no children */
      },
  _definePage_default_123
  ),
      {
        path: 'service-desk',
        /* internal name: 'app-service-desk' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: 'dashboard',
            name: 'app-service-desk-dashboard',
            component: () => import('/app/src/pages/app/service-desk/dashboard.vue'),
            /* no children */
          },
  _definePage_default_124
  ),
          {
            path: 'master',
            /* internal name: 'app-service-desk-master' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: 'task',
                name: 'app-service-desk-master-task',
                component: () => import('/app/src/pages/app/service-desk/master/task.vue'),
                /* no children */
              },
  _definePage_default_125
  )
            ],
          },
          {
            path: 'ticket-management',
            /* internal name: 'app-service-desk-ticket-management' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'app-service-desk-ticket-management',
                component: () => import('/app/src/pages/app/service-desk/ticket-management/index.vue'),
                /* no children */
              },
  _definePage_default_126
  )
            ],
          },
          {
            path: 'utility',
            /* internal name: 'app-service-desk-utility' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: 'qrcode',
                name: 'app-service-desk-utility-qrcode',
                component: () => import('/app/src/pages/app/service-desk/utility/qrcode.vue'),
                /* no children */
              },
  _definePage_default_127
  )
            ],
          }
        ],
      },
      {
        path: 'survey',
        /* internal name: 'app-survey' */
        /* no component */
        children: [
          {
            path: 'collection',
            /* internal name: 'app-survey-collection' */
            /* no component */
            children: [
              {
                path: 'customer',
                /* internal name: 'app-survey-collection-customer' */
                /* no component */
                children: [
  _mergeRouteRecord(
                  {
                    path: '',
                    name: 'app-survey-collection-customer',
                    component: () => import('/app/src/pages/app/survey/collection/customer/index.vue'),
                    /* no children */
                  },
  _definePage_default_128
  ),
  _mergeRouteRecord(
                  {
                    path: 'view',
                    name: 'app-survey-collection-customer-view',
                    component: () => import('/app/src/pages/app/survey/collection/customer/view.vue'),
                    /* no children */
                  },
  _definePage_default_129
  )
                ],
              },
  _mergeRouteRecord(
              {
                path: 'view',
                name: 'app-survey-collection-view',
                component: () => import('/app/src/pages/app/survey/collection/view.vue'),
                /* no children */
              },
  _definePage_default_130
  )
            ],
          },
          {
            path: 'customer',
            /* internal name: 'app-survey-customer' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'app-survey-customer',
                component: () => import('/app/src/pages/app/survey/customer/index.vue'),
                /* no children */
              },
  _definePage_default_131
  ),
  _mergeRouteRecord(
              {
                path: 'analytics',
                name: 'app-survey-customer-analytics',
                component: () => import('/app/src/pages/app/survey/customer/analytics.vue'),
                /* no children */
              },
  _definePage_default_132
  ),
  _mergeRouteRecord(
              {
                path: 'setup',
                name: 'app-survey-customer-setup',
                component: () => import('/app/src/pages/app/survey/customer/setup.vue'),
                /* no children */
              },
  _definePage_default_133
  ),
  _mergeRouteRecord(
              {
                path: 'subscriptions',
                name: 'app-survey-customer-subscriptions',
                component: () => import('/app/src/pages/app/survey/customer/subscriptions.vue'),
                /* no children */
              },
  _definePage_default_134
  )
            ],
          },
          {
            path: 'dashboard',
            /* internal name: 'app-survey-dashboard' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'app-survey-dashboard',
                component: () => import('/app/src/pages/app/survey/dashboard/index.vue'),
                /* no children */
              },
  _definePage_default_135
  )
            ],
          },
          {
            path: 'employee',
            /* internal name: 'app-survey-employee' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'app-survey-employee',
                component: () => import('/app/src/pages/app/survey/employee/index.vue'),
                /* no children */
              },
  _definePage_default_136
  ),
              {
                path: 'setup',
                name: 'app-survey-employee-setup',
                component: () => import('/app/src/pages/app/survey/employee/setup.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'event',
            /* internal name: 'app-survey-event' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'app-survey-event',
                component: () => import('/app/src/pages/app/survey/event/index.vue'),
                /* no children */
              },
  _definePage_default_137
  ),
              {
                path: 'setup',
                name: 'app-survey-event-setup',
                component: () => import('/app/src/pages/app/survey/event/setup.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'ticket-management',
            /* internal name: 'app-survey-ticket-management' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'app-survey-ticket-management',
                component: () => import('/app/src/pages/app/survey/ticket-management/index.vue'),
                /* no children */
              },
  _definePage_default_138
  )
            ],
          }
        ],
      },
  _mergeRouteRecord(
      {
        path: 'two-step',
        name: 'app-two-step',
        component: () => import('/app/src/pages/app/two-step.vue'),
        /* no children */
      },
  _definePage_default_139
  )
    ],
  },
  {
    path: '/care-visit',
    /* internal name: 'care-visit' */
    /* no component */
    children: [
      {
        path: 'kiosk',
        /* internal name: 'care-visit-kiosk' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: 'check-in',
            name: 'care-visit-kiosk-check-in',
            component: () => import('/app/src/pages/care-visit/kiosk/check-in.vue'),
            /* no children */
          },
  _definePage_default_140
  ),
  _mergeRouteRecord(
          {
            path: 'check-out',
            name: 'care-visit-kiosk-check-out',
            component: () => import('/app/src/pages/care-visit/kiosk/check-out.vue'),
            /* no children */
          },
  _definePage_default_141
  ),
  _mergeRouteRecord(
          {
            path: 'panel',
            name: 'care-visit-kiosk-panel',
            component: () => import('/app/src/pages/care-visit/kiosk/panel.vue'),
            /* no children */
          },
  _definePage_default_142
  ),
  _mergeRouteRecord(
          {
            path: 'registration',
            name: 'care-visit-kiosk-registration',
            component: () => import('/app/src/pages/care-visit/kiosk/registration.vue'),
            /* no children */
          },
  _definePage_default_143
  )
        ],
      },
      {
        path: 'visitor',
        /* internal name: 'care-visit-visitor' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: 'pass',
            name: 'care-visit-visitor-pass',
            component: () => import('/app/src/pages/care-visit/visitor/pass.vue'),
            /* no children */
          },
  _definePage_default_144
  )
        ],
      }
    ],
  },
  {
    path: '/ComingSoon',
    name: 'coming-soon',
    component: () => import('/app/src/pages/ComingSoon.vue'),
    /* no children */
  },
  {
    path: '/documentation',
    /* internal name: 'documentation' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: ':slug(.*)',
        name: 'documentation$slug',
        component: () => import('/app/src/pages/documentation/[...slug].vue'),
        /* no children */
      },
  _definePage_default_145
  )
    ],
  },
  {
    path: '/feedback-collect',
    /* internal name: 'feedback-collect' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'feedback-collect',
        component: () => import('/app/src/pages/feedback-collect/index.vue'),
        /* no children */
      },
  _definePage_default_146
  )
    ],
  },
  {
    path: '/service-desk',
    /* internal name: 'service-desk' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'service-desk',
        component: () => import('/app/src/pages/service-desk/index.vue'),
        /* no children */
      },
  _definePage_default_147
  )
    ],
  },
  {
    path: '/survey-collect',
    /* internal name: 'survey-collect' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'survey-collect',
        component: () => import('/app/src/pages/survey-collect/index.vue'),
        /* no children */
      },
  _definePage_default_148
  )
    ],
  },
  {
    path: '/visitor-pass',
    /* internal name: 'visitor-pass' */
    /* no component */
    children: [
      {
        path: ':code',
        name: 'visitor-pass-code',
        component: () => import('/app/src/pages/visitor-pass/[code].vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/visitor-registration',
    /* internal name: 'visitor-registration' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'visitor-registration',
        component: () => import('/app/src/pages/visitor-registration/index.vue'),
        /* no children */
      },
  _definePage_default_149
  ),
      {
        path: 'simple',
        name: 'visitor-registration-simple',
        component: () => import('/app/src/pages/visitor-registration/simple.vue'),
        /* no children */
      },
      {
        path: 'test',
        name: 'visitor-registration-test',
        component: () => import('/app/src/pages/visitor-registration/test.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/wecarexm-ai',
    /* internal name: 'wecarexm-ai' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'wecarexm-ai',
        component: () => import('/app/src/pages/wecarexm-ai/index.vue'),
        /* no children */
      },
  _definePage_default_150
  )
    ],
  }
]
